import {
  getDocumentCollection,
  getDocumentsFetchingVersions,
  getDocumentsVersions,
  getFetchingIssuesUrns,
  getProjectId
} from '../selectors';
import {
  DOCUMENT_COLLECTION_CONFIGURE,
  DOCUMENT_VERSIONS_API_FULFILLED,
  DOCUMENT_VERSIONS_API_START,
  DOCUMENTS_WITH_ISSUES_FETCH
} from './configuration-actions';
import lodashKeyBy from 'lodash/keyBy';
import isEmpty from 'lodash/isEmpty';

const fetchDocumentVersions = ({urn, parentFolderUrn}) => (dispatch, getState, {docsSDK}) => {
  dispatch({type: DOCUMENT_VERSIONS_API_START, payload: {urn}});
  const projectId = getProjectId(getState());
  docsSDK.getDocumentVersions(projectId, parentFolderUrn, urn).then(versions => {
    dispatch({
      type: DOCUMENT_VERSIONS_API_FULFILLED,
      payload: {
        urn,
        versions: lodashKeyBy(versions, 'versionNumber')
      }
    });
  });
};

export const fetchDocumentsWithIssues = urns => (dispatch, getState, {docsSDK}) => {
  dispatch({type: DOCUMENTS_WITH_ISSUES_FETCH, payload: urns});
  if (!isEmpty(urns)) {
    docsSDK.getDocumentsByURNs(getProjectId(getState()), urns).then(result => {
      const formattedDocuments = result.map(document => ({
        urn: document.urn,
        name: document.currentVersion.title,
        version: document.latestVersion,
        bubbleUrn: document.currentVersion.bubbleUrn,
        fileName: document.currentVersion.fileName,
        parentFolderUrn: document.parentFolderUrn
      }));

      const documentCollection = urns.reduce((acc, urn) => {
        // Init objects for all requested URNs. That way unavailable document URNs exist as keys with empty values,
        // so we can differ between not yet requested documents & not available ones.
        acc[urn] = {};
        return acc;
      }, {});

      formattedDocuments.forEach(document => {
        documentCollection[document.urn] = document;
      });

      dispatch({
        type: DOCUMENT_COLLECTION_CONFIGURE,
        payload: documentCollection
      });
      const state = getState();
      const documentsFetchingVersions = getDocumentsFetchingVersions(state);
      formattedDocuments
        .filter(({urn}) => !documentsFetchingVersions.includes(urn))
        .forEach(({urn, parentFolderUrn}) => {
          dispatch(fetchDocumentVersions({urn, parentFolderUrn}));
        });
    });
  }
};

export const fetchDocumentDetailsIfMissing = urn => (dispatch, getState) => {
  const state = getState();
  const documentCollection = getDocumentCollection(state);
  const document = documentCollection[urn];
  if (!document) {
    const fetchingIssuesUrns = getFetchingIssuesUrns(getState());
    if (!fetchingIssuesUrns.includes(urn)) {
      dispatch(fetchDocumentsWithIssues([urn]));
    }
  } else if (!isEmpty(document)) {
    const documentVersions = getDocumentsVersions(state);
    if (!documentVersions[urn]) {
      const documentsFetchingVersions = getDocumentsFetchingVersions(state);
      if (!documentsFetchingVersions.includes(urn)) {
        dispatch(fetchDocumentVersions({urn, parentFolderUrn: document.parentFolderUrn}));
      }
    }
  }
};
